<template>
	<div
		class="image-slider insicht"
		v-if="images.length"
	>
		<vue-glide
			ref="glide"
			v-bind="glideOptions"
		>
			<vue-glide-slide
				class="image-slider__slide"
				v-for="image in images"
				:key="image.id"
			>
				<img
					ref="image"
					class="image-slider__slide-image"
					:srcset="image.image.srcset"
					:src="image.image.src"
					:alt="image.title"
					data-object-fit
					loading="lazy"
				>
			</vue-glide-slide>
		</vue-glide>
	</div>
</template>

<script>
import { Glide, GlideSlide } from 'vue-glide-js'

export default {
	components: {
		'vue-glide': Glide,
		'vue-glide-slide': GlideSlide,
	},
	data() {
		return {
			images: this.$root.options.images || [],
			glideOptions: {
				bullet: true,
				type: 'carousel',
				startAt: 0,
				perView: 1,
				focusAt: 'center',
				gap: 0,
				autoplay: 0,
				hoverpause: true,
				keyboard: false,
				bound: false,
				swipeThreshold: 80,
				dragThreshold: 120,
				perTouch: 0,
				touchRatio: 0.5,
				touchAngle: 45,
				animationDuration: 100,
				rewind: true,
				peek: 0,
			},
		};
	},
	mounted() {
		// objectFitImages(this.$refs.image);
	},
}
</script>

<style>
</style>
